import { useState } from "react";
import { Link } from "react-router-dom";
import { img, inr, useGet } from "@/lib/api";
import { useSeo } from "@/lib/store";

function Design({ a, i }) {
  const views = [["Artwork", a.art], ["Front Tee", a.front], ["Back Tee", a.back], ["Hoodie", a.hoodie]].filter(([, u]) => u);
  const [v, setV] = useState(0);
  return (
    <article id={a.slug} className={`grid lg:grid-cols-2 gap-10 lg:gap-16 items-center py-20 border-t border-white/10 scroll-mt-24`} data-testid={`anime-design-${a.slug}`}>
      <div className={i % 2 ? "lg:order-2" : ""}>
        <div className="relative aspect-[4/5] bg-black overflow-hidden">
          <img key={v} src={img(views[v][1])} alt={`${a.title} ${views[v][0]}`} className="w-full h-full object-cover reveal" loading="lazy" data-testid={`anime-view-image-${a.slug}`} />
          <span className="absolute top-4 left-4 font-display text-7xl text-white/10">{a.code}</span>
        </div>
        <div className="grid grid-cols-4 gap-2 mt-2">
          {views.map(([l, u], k) => (
            <button key={l} onClick={() => setV(k)} data-testid={`anime-view-${a.slug}-${k}`} className={`relative aspect-square overflow-hidden border-2 ${v === k ? "border-neon" : "border-transparent"}`}>
              <img src={img(u)} alt={l} className="w-full h-full object-cover" loading="lazy" />
              <span className="absolute bottom-0 inset-x-0 bg-black/70 text-[9px] font-mono py-1 text-center">{l.toUpperCase()}</span>
            </button>
          ))}
        </div>
      </div>
      <div>
        <p className="font-mono text-xs tracking-[.3em] text-red-500">DESIGN {a.code}</p>
        <h2 className="font-display text-6xl sm:text-7xl lg:text-8xl leading-[0.85] mt-3">{a.title}</h2>
        <div className="flex gap-2 mt-5">{a.palette?.map((c) => <span key={c} className="w-6 h-6 border border-white/20" style={{ background: c }} />)}</div>
        <p className="text-white/70 mt-6 max-w-md text-lg leading-relaxed">{a.description}</p>
        <p className="text-grey text-sm mt-4 font-mono">FRONT: small DEN & THREADS chest logo · BACK: full artwork print</p>
        <p className="font-mono text-3xl mt-8" data-testid={`anime-price-${a.slug}`}>from {inr(a.price)}</p>
        <div className="flex flex-wrap gap-3 mt-8">
          <Link to={`/product/${a.product_slug}`} className="btn-neon" data-testid={`anime-choose-${a.slug}`}>Choose this design</Link>
          <Link to={`/custom-printing?design=${a.slug}`} className="btn-ghost" data-testid={`anime-customize-${a.slug}`}>Customize this design</Link>
          <Link to={`/wholesale?design=${a.slug}`} className="btn-ghost" data-testid={`anime-bulk-${a.slug}`}>Request bulk printing</Link>
        </div>
      </div>
    </article>
  );
}

export default function Anime() {
  useSeo("Anime After Dark — Original Anime Streetwear", "Four original anime-inspired artworks printed on premium oversized tees and hoodies. Shadow Samurai, Cyber Phantom, Ronin Spirit, Demon Awakening.");
  const { data = [] } = useGet("/anime");
  return (
    <div data-testid="anime-page">
      <section className="relative overflow-hidden bg-[#050505] grain">
        <div className="max-w-[1500px] mx-auto px-4 sm:px-8 py-24 sm:py-32 relative">
          <p className="eyebrow text-red-500">Exclusive collection · Original artwork</p>
          <h1 className="font-display text-[20vw] sm:text-[14vw] lg:text-[11rem] leading-[0.8] mt-6">ANIME<br /><span className="text-red-600">AFTER</span> DARK</h1>
          <p className="max-w-xl text-white/70 mt-8 text-lg">Four original manga-born designs, drawn for the den. Every piece wears a small chest logo up front — and the full story on the back.</p>
        </div>
        <div className="absolute right-0 top-0 h-full w-1/2 hidden lg:grid grid-cols-2 opacity-40">
          {data.slice(0, 4).map((a) => <img key={a.slug} src={img(a.art)} alt="" className="w-full h-full object-cover" />)}
        </div>
      </section>
      <div className="max-w-[1500px] mx-auto px-4 sm:px-8">{data.map((a, i) => <Design key={a.id} a={a} i={i} />)}</div>
    </div>
  );
}
